import {createReducer} from '../../base/fsa/createReducer';
import {initialSettingsState} from './state';
import {setSettingsAction} from './actions';

export const settingsReducer = createReducer(initialSettingsState, handle => [
    handle(setSettingsAction, (state, action) => {
        return {
            ...action.payload,
        };
    }),
]);
